export default __webpack_public_path__ + "static/media/claims.f9254204.jpg";